module.exports = new __parcel__URL__("hubHeaderBlack.1476676c.svg").toString();